import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../../settings";
import FreeSpinOverlayReel from "../FreeSpinOverlayReel/FreeSpinOverlayReel";
import { useReelRefs } from "../../../Contexts/ReelRefsContext";
import { useDimensions } from "../../../Contexts/DimensionsContext";
import { useSelector } from "react-redux";
import { selectFreeSpinActive } from "../../../State/selectors";

const FreeSpinOverlayReelset = memo(() => {
  const { freeSpinOverlayReelRefs } = useReelRefs();
  const { symbolHeight, reelSpacing, symbolWidth } = useDimensions();
  const freeSpinActive = useSelector(selectFreeSpinActive);

  // Y offset — identical to main OverlayReelSet
  const containerY = useMemo(
    () => -symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5),
    [symbolHeight]
  );

  return (
    <Container
      name="free_spin_spine_overlay"
      zIndex={5}
      y={containerY}
      visible={freeSpinActive}
    >
      {GAME_LAYOUT.REEL_INDICES.map((index) => (
        <FreeSpinOverlayReel
          key={index}
          index={index}
          symbolWidth={symbolWidth}
          symbolHeight={symbolHeight}
          reelSpacing={reelSpacing}
          freeSpinOverlaySymbols={GAME_LAYOUT.SYMBOL_INDICES}
          ref={(el) => {
            freeSpinOverlayReelRefs.current[index] = el;
          }}
        />
      ))}
    </Container>
  );
});

export default FreeSpinOverlayReelset;
